import { fetchPropertyLogic } from './fetchPropertyLogic';

export const logic = [fetchPropertyLogic];
